/**
 * @module builder
 */
export function getOrderOptions() {
  return ['area', 'substrate', 'crew', 'areaOptions']
}
